import classes from './email-verify.module.scss';
import { Wrapper } from '../../components/shared/wrapper.component';
import { Alert, Button } from 'antd';
import { CaretRightFilled } from '@ant-design/icons';
import useVerifyEmail from '../../Hooks/email-verification.hook';
import { useTranslation } from 'react-i18next';
import { localizedPath } from '../../utils/localized-route';

const EmailConfirm = () => {
  const { t } = useTranslation();
  const { state, sendToken, dest } = useVerifyEmail();

  return (
    <Wrapper>
      {
        state.valid
          ? (
            <div className={classes.resetPasswordContainer}>
              <div className={classes.textContainer}>
                <h1 className={classes.title}>{t('email-verification.verified-title')}</h1>
                <p className={classes.text}>{t('email-verification.verified-description')}</p>
                <Button
                  type="primary"
                  href={localizedPath(dest ? `/login?${new URLSearchParams({ dest }).toString()}` : '/login')}
                  className={classes.action}
                >
                  {t('register.login')} <CaretRightFilled />
                </Button>
              </div>
            </div>
          ) : (
            <div className={classes.resetPasswordContainer}>
              <div className={classes.textContainer}>
                <h1 className={classes.title}>{t('email-verification.failed-title')}</h1>
                <p className={classes.text}>{t('email-verification.failed-description')}</p>
                <Button
                  type="primary"
                  onClick={sendToken}
                  className={classes.action}
                  disabled={Boolean(state.tokenResent)}
                >
                  {t('email-verification.resend')}
                </Button>
              </div>
              <br /><br />
              {
                state.tokenResent
                && (
                  <Alert
                    message={state.tokenResent?.success ? state.tokenResent.msg : state.tokenResent.msg}
                    showIcon
                    type={state.tokenResent?.success ? "success" : "error"}
                    closable
                  />
                )
              }
            </div>
          )
      }
    </Wrapper>
  );
};

export default EmailConfirm;